import { render } from "./ApprovalButton.vue?vue&type=template&id=4e689916"
import script from "./ApprovalButton.vue?vue&type=script&lang=js"
export * from "./ApprovalButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__